/**
 * SectionCommentButton — Affordance in section headers to add a section-level comment.
 *
 * Renders a small comment icon button. On click, opens the comment margin zone
 * (if not already open) and scrolls to / activates an inline input for the
 * target section.
 *
 * See: docs/features/document-system/document-comments.md (Phase 2)
 */
import React from "react";
import { MessageSquarePlus } from "lucide-react";
import Tooltip from "@mui/material/Tooltip";

const SectionCommentButton = ({ sectionKey, sectionTitle, onAddSectionComment }) => {
  if (!onAddSectionComment) return null;

  return (
    <Tooltip title="Add comment" arrow>
      <span
        className="section-comment-btn"
        role="button"
        tabIndex={0}
        aria-label={`Add comment to ${sectionTitle}`}
        onClick={(e) => {
          e.stopPropagation();
          onAddSectionComment(sectionKey, sectionTitle);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.stopPropagation();
            onAddSectionComment(sectionKey, sectionTitle);
          }
        }}
      >
        <MessageSquarePlus size={12} />
      </span>
    </Tooltip>
  );
};

export default React.memo(SectionCommentButton);
